// Recovered compiled webpack factory 97684. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { B: () => i });
  var n = r(14356),
    a = r(95704),
    o = r(49636);
  function i() {
    return (
      "undefined" != typeof window &&
      (!(
        !(0, n.Z)() && "[object process]" === Object.prototype.toString.call(void 0 !== a ? a : 0)
      ) ||
        (function () {
          let e = o.O.process;
          return e?.type === "renderer";
        })())
    );
  }
}
